import { Injectable } from '@angular/core';
import { IAuthEvent } from '../models/broadcast-auth-event.interface';
import { Subject } from 'rxjs';

@Injectable()
export class BroadcastService {
  public broadcast$ = new Subject<IAuthEvent>();

  public emit(event: IAuthEvent) {
    this.broadcast$.next(event);
  }
}
